import { render, staticRenderFns } from "./AddUntyped.vue?vue&type=template&id=04a16ef0&scoped=true"
import script from "./AddUntyped.vue?vue&type=script&lang=js"
export * from "./AddUntyped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a16ef0",
  null
  
)

export default component.exports